import { link, text } from './story';

const location = {
  title: 'Location',
  attributes: {
    title: {},
    avatar: { type: 'image', keyboard: 'url' },
    country: { style: 'inline2' },
    author: { style: 'inline2' },
  },
};

const info = {
  title: 'Info',
  attributes: {
    title: {},
    text,
    location,
  },
};

export default {
  DEFAULT: {
    id: { disabled: true, required: true, style: 'inline4' },
    page: {
      label: 'Page Number', keyboard: 'numeric', required: true, style: 'inline4',
    },
    type: {
      type: 'select',
      required: true,
      defaultValue: 'content',
      dataSource: ['title', 'content', 'chapter', 'media', 'gallery', 'slider', 'footer'],
      style: 'inline2',
    },
    background: {
      title: 'Background',
      style: 'inline2',
      attributes: {
        image: { type: 'image', keyboard: 'url' },
        video: { keyboard: 'url' },
        color: { style: 'inline4' },
        opacity: { keyboard: 'numeric', style: 'inline4' },
        loop: { type: 'bool', style: 'inline4' },
        mute: { type: 'bool', style: 'inline4' },
      },
    },
    color: { style: 'inline4' },
    motion: { type: 'bool', style: 'inline4' },
  },

  TITLE: {
    title: { required: true },
    subtitle: {},
    image: { type: 'image', keyboard: 'url' },
    link,
    info,
    location,
  },

  CHAPTER: {
    title: {},
    number: { keyboard: 'numeric' },
  },

  CONTENT: {
    title: {},
    text: { ...text, required: true },
    image: {
      title: 'image',
      attributes: {
        source: { type: 'image', keyboard: 'url', required: true },
        uri: { keyboard: 'url' },
      },
    },
    link,
    rights: { style: 'inline2' },
    style: {
      type: 'select',
      dataSource: ['', 'left', 'right', 'center', 'box'],
      style: 'inline2',
    },
  },

  MEDIA: {
    title: {},
    text,
    image: { type: 'image', keyboard: 'url' },
    video: { keyboard: 'url' },
    location,
    rights: {},
  },

  GALLERY: {
    images: { type: 'list' },
    rights: {},
  },

  SLIDER: {
    images: { type: 'list', required: true },
    texts: { type: 'list' },
  },

  FOOTER: {
    title: {},
    subtitle: {},
    image: { type: 'image', keyboard: 'url' },
    link,
  },
};
